import request from '@/utils/request'

//进货批次—列表
export const purchase_list = (data) => {
    return request({
        url: '/erp/base-goods-batch/index',
        method: 'get',
        data
    })
}

//进货批次—详情
export const purchase_Detail = (data) => {
    return request({
        url: '/erp/base-goods-batch/detail',
        method: 'get',
        data
    })
}